module.exports = __webpack_public_path__ + "static/media/snappyRetention.a2b821cf.svg";